/* global Raven */
export function captureMessage(msg) {
  if (window.Raven) {
    Raven.captureMessage(msg);
  } else {
    console && console.info('Raven would capture message: ', msg);
  }
}

export function captureException(err) {
  if (window.Raven) {
    Raven.captureException(err);
  } else {
    console && console.error('Raven would capture exception: ', err);
  }
}

export default {
  captureMessage,
  captureException
};



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/logger.js